
<ng-template [ngIf]="!multi">
  <div class="header"><b>Error:</b><span> {{ error?.message }}</span><span *ngIf="allowSelfAssign">
      <button class="btn btn-sm float-right btn-outline-dark" type="button" style="margin-top: -0.25em;" (click)="assignMeToProject()">Assign Me to Project</button></span></div>
  <ng-container [ngSwitch]="error.name">
    <div class="validation-errors" *ngSwitchCase="'ValidationError'"><span *ngFor="let e of error?.validationErrors">{{ e.processed }}</span></div>
    <div class="validation-errors" *ngSwitchCase="'MultiValidationError'"><span *ngFor="let e of error?.validationErrors">{{ e.processed }}</span></div>
    <div class="validation-error-rows" *ngSwitchCase="'MultiValidationError'">
      <div class="validation-error-row" *ngFor="let r of error?.validationErrorRows"><span>{{ r?.header }}:</span><span *ngFor="let e of r?.error">{{ e.processed }}</span></div>
    </div>
    <div class="missing-column-error-rows" *ngSwitchCase="'WorkbookMissingColumnsError'">
      <div class="missing-column-error-row" *ngFor="let s of error.missingSheets"><span>Missing sheet "{{ s }}"</span></div>
      <div class="missing-column-error-row" *ngFor="let e of error.missingColumns"><span>Missing columns for "{{ e?.sheetName }}":</span><span *ngFor="let c of e?.columnNames">{{ c }}</span></div>
    </div>
    <table class="table table-sm cdf-validation-error-table" *ngSwitchCase="'CDFValidationError'">
      <thead>
        <tr>
          <th>Deal</th>
          <th>Map ID</th>
          <th>SKU</th>
          <th>Disposition</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let issue of error.issues">
          <td>{{ issue.cdfId }}</td>
          <td>{{ issue.floorMapId }}</td>
          <td><span class="oi oi-x invalid" *ngIf="issue.reasonsMap.productNumber"></span> {{ issue.productNumber || "(empty)" }}</td>
          <td><span class="oi oi-x invalid" *ngIf="issue.reasonsMap.disposition"></span> {{ issue.disposition || "(empty)" }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</ng-template>
<ng-template [ngIf]="multi">
  <div class="error-multi-row" *ngFor="let e of error.errors">
    <error-display [error]="e"></error-display>
    <div class="clearfix"></div>
  </div>
</ng-template>